import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, makeStyles, Theme, useTheme } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from '../../components/Button';
import TextInput from '../../components/TextInput';
import Form from '../../components/Form';
import { StyledText } from '../../components/StyledText';
import BasicProfileHolder from '../../components/BasicProfileHolder';
import { BasicProfileData, InvestorReferralResponse } from '../../types/types';

const validationSchema = Yup.object().shape({
  message: Yup.string().optional().trim()
});


interface ReferralResponseModalProps {
  response: InvestorReferralResponse | undefined
  connector: BasicProfileData
  onClose: () => void
  handleSubmit: (message: string, resp: InvestorReferralResponse) => void
}

const initialValues = {
  message: ''
};

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    marginBottom: '8px',
    color: '#2F2F33'
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: '19px'
  },
  connectorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  }
}));

const ReferralResponseModal: React.FC<ReferralResponseModalProps> = ({
  response,
  onClose,
  connector,
  handleSubmit
}) => {
  const formikOnSubmit = (values: any) => {
    if (!response) return;
    const { message } = values;
    handleSubmit(message, response);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: formikOnSubmit,
    validateOnMount: true
  });

  useEffect(() => {
    if (!response) {
      formik.resetForm();
    }
    if (response === InvestorReferralResponse.Accept) {
      setTitleText(['Refer me', `Do you have any questions or comments about the deal for ${name}?`]);
    } else if (response === InvestorReferralResponse.Decline) {
      setTitleText(['Do not refer me', `Let ${name} know why this deal is not a good fit`]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const { name } = connector;
  const [titleText, setTitleText] = useState(['', '']);
  const [title, subtitle] = titleText;
  const styles = useStyles();
  const theme = useTheme();

  return (
    <Dialog
      open={response !== undefined}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
    >
      <DialogContent>
        <Form formik={formik}>
          <StyledText variant='h2' className={styles.title}>
            {title}
          </StyledText>
          <StyledText variant='body3' className={styles.subtitle}>
            {subtitle}
          </StyledText>
          <Box className={styles.connectorContainer}>
            <StyledText
              style={{ fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                color: theme.palette.text.secondary,
                marginRight: '20px' }}
            >
              To
            </StyledText>
            <BasicProfileHolder
              profile={connector}
            />
          </Box>
          <TextInput
            id='message'
            fullWidth
            type='text'
            label='Message (optional)'
            placeholder=''
            multiline
            rows={7}
          />
          <DialogActions>
            <Button type='button' variant='text' onClick={onClose}>Cancel</Button>
            <Button type='submit' variant='contained' disabled={!formik.isValid || formik.isSubmitting}>Send</Button>
          </DialogActions>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default ReferralResponseModal;
